import PropTypes from 'prop-types';

import CrmAddressCard from '#/modules/crmMgmt/components/CrmAddressCard';
import CrmCustomerSnapshotMeta from '#/modules/crmMgmt/components/CrmCustomerSnapshotMeta';
import {
  mapSalesOrderCustomerSnapshotFields,
  mapSalesOrderShippingAddress,
} from '#/modules/crmMgmt/salesOrder/helper/mapSalesOrderMeta';

const SalesOrderShippingReadonlySection = ({ detail }) => {
  const snapshot = mapSalesOrderCustomerSnapshotFields(detail);
  const shippingAddress = mapSalesOrderShippingAddress(detail);

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <h2 className="text-base font-semibold text-gray-900">客戶／地址快照</h2>
        <div className="mt-4 space-y-4">
          <CrmCustomerSnapshotMeta snapshot={snapshot} />
          <div className="grid grid-cols-1 gap-3">
            <CrmAddressCard title="收貨地址" address={shippingAddress} />
          </div>
        </div>
      </div>
    </div>
  );
};

SalesOrderShippingReadonlySection.propTypes = {
  detail: PropTypes.object.isRequired,
};

export default SalesOrderShippingReadonlySection;
